export default __webpack_public_path__ + "static/media/marker-red.e53a72f9.svg";